<script>
import axios from "@/axios";
import { Message } from "element-ui";
import { mapActions } from "vuex";

export default {
  data() {
    return {
      creditAmount: 0,
      replyCode: null,
      error: null
    };
  },
  computed: {
    isReturningFromSuccessfulPayment() {
      return this.replyCode != null
    }
  },
  methods: {
    ...mapActions(["fetchUserInfo"]),
    async redirectToPaymentPage() {
      try {
        const response = await axios.post("/credits/recharge", {
          amount: this.creditAmount,
        });
        const data = response.data?.data ?? {}
        if (data.payment_link) {
          window.location.href = data.payment_link;
        } else {
          Message.error("Failed to redirect to payment page");
        }
      } catch (e) {
        if (e.response.data.error_key === 'credits.pending_payment_already_present') {
          const paymentLink = e.response.data.additional_data?.payment_link

          this.error = 'A pending payment already exists, redirecting to payment page to complete it...'

          if (paymentLink) {
            window.location.href = paymentLink;
          } else {
            Message.error("Failed to redirect to payment page");
          }
        } else {
          this.error = e.response.data.message;
        }
      }
      
    },
    async registerPaymentAsComplete() {
      try {
        await axios.post(
          "/credits/manage-payment-response" + window.location.search,
        );
        await this.fetchUserInfo();
      } catch (e) {
        this.error = e.response.data.message;
        this.replyCode = null;
      }
    },
  },
  beforeMount() {
    this.$preloader.fadeOut();
  },
  async mounted() {
    this.replyCode = this.$route.query.replyCode ?? null;
    this.creditAmount = this.$route.query.creditAmount ?? 0

    if(this.isReturningFromSuccessfulPayment) {
      await this.registerPaymentAsComplete();
      window.location.href = '/'
    } else {
      if (this.creditAmount <= 0) {
        this.error = "You can't proceed with the purchase of 0 or less credits"
        return
      }
      await this.redirectToPaymentPage()
    }
  },
};
</script>

<template>
  <div class="wrapper">
    <div class="card" v-if="!isReturningFromSuccessfulPayment">
      <h1>Redirecting to payment page...</h1>
      <p>Preparing purchase of {{ creditAmount }} credits</p>
      <div class="errors">
        <p v-if="error" class="error">{{ error }}</p>
      </div>
    </div>
    <div class="card" v-else>
      <h1 class="text-center success">Thank you for your purchase!</h1>
      <p class="mb-4">Everything is set up. You'll be redirected shortly!</p>
    </div>
  </div>
</template>

<style scoped>
.wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.card {
  width: min(100%, 400px);
  padding: 16px;
  border-radius: 8px;
  background: white;

  & > .errors > .error {
    color: red !important;
  }

  & > * {
    color: black;
  }

  & > h1 {
    font-size: 24px;
    margin-bottom: 16px;
    &.success {
      color: green;
    }
  }
}
</style>
